
export enum AdvancedSearchType {
    Vessel = 0,
    Company = 1
}